import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { AuthContext } from '../../context/AuthContext';
import { usePermissions } from '../../hooks/usePermissions';

/**
 * Route-guard op basis van permissies uit config/permissions.js.
 * Gebruik binnen <RequireAuth>. Wacht tot de rol geladen is; zonder die wachttijd
 * is hasPermission() kort `false` en volgt een onterechte redirect na een refresh.
 *
 * @example
 * <RequireAuth>
 *   <RequirePermission permission={PERMISSIONS.VIEW_METRICS}>
 *     <Metrics />
 *   </RequirePermission>
 * </RequireAuth>
 */
export default function RequirePermission({ permission, anyOf, redirectTo = '/', children }) {
  const { role, roleLoading } = useContext(AuthContext);
  const { hasPermission, hasAnyPermission } = usePermissions();

  if (!role || roleLoading) {
    return (
      <Box
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}
      >
        <CircularProgress size={32} />
      </Box>
    );
  }

  const allowed = anyOf ? hasAnyPermission(anyOf) : hasPermission(permission);
  if (!allowed) return <Navigate to={redirectTo} replace />;

  return children;
}
